import { render, staticRenderFns } from "./ContactListAddNew.vue?vue&type=template&id=25dc3999"
import script from "./ContactListAddNew.vue?vue&type=script&lang=js"
export * from "./ContactListAddNew.vue?vue&type=script&lang=js"
import style0 from "./ContactListAddNew.vue?vue&type=style&index=0&id=25dc3999&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports